/* lua.js generated code 0.3.0 */

require("hecore/init")

PlatformNameEnum = table(
    [1, "kIOS", "apple"],
    [1, "kHE", "he"],
    [1, "kQQ", "yingyongbao"]
    // [1, "kYYB_CENTER", "yybcenter"],
    // [1, "kYYB_MARKET", "yybmarket"],
    // [1, "kYYB_JINSHAN", "yybjinshan"],
    // [1, "kYYB_BROWSER", "yybbrowser"],
    // [1, "kYYB_ZONE", "yybzone"],
    // [1, "kYYB_VIDEO", "yybvideo"],
    // [1, "kYYB_NEWS", "yybnews"],
    // [1, "kYYB_QQ", "yybqq"],
    // [1, "kYYB_PC", "yybpc"],
    // [1, "kYYB_CORE", "yybcore"],
    // [1, "kYYB_SHOP", "yybshop"],
    // [1, "kYYB_TMS_CENTER", "yybtmscenter"],
    // [1, "kYYB_TMS_SHOP", "yybtmsshop"],
    // [1, "kYYB_GUANJIA", "yybguanjia"],
    // [1, "k360", "360"],
    // [1, "kDuoku", "duoku"],
    // [1, "kWDJ", "wandoujia"],
    // [1, "kMI", "mi"],
    // [1, "kMiTalk", "mitalk"],
    // [1, "kBaiDuApp", "baiduapp"],
    // [1, "kBaiDuTieBa", "tieba"],
    // [1, "k91", "91"],
    // [1, "kHao123", "hao123"],
    // [1, "kOppo", "oppo"],
    // [1, "kBBK", "bbk"],
    // [1, "kTYD", "tianyida"],
    // [1, "kJinShan", "jinshan"],
    // [1, "kLenovo", "lenovo"],
    // [1, "kLenovopc", "lenovopc"],
    // [1, "kHuaWei", "huawei"],
    // [1, "kMiPad", "mipad"],
    // [1, "kCMCCMM", "cmccmm"],
    // [1, "kCUCCWO", "cuccwo"],
    // [1, "kCoolpad", "coolpad"],
    // [1, "kAnZhi", "anzhi"],
    // [1, "kUUCun", "uucun"],
    // [1, "kCooou", "cooou"],
    // [1, "kCMGame", "cmgame"],
    // [1, "kYouKu", "youku"],
    // [1, "kZTEPre", "zte_pre"],
    // [1, "kJinli", "jinli"],
    // [1, "kHEMM", "hemm"],
    // [1, "kJinliPre", "jinli_pre"],
    // [1, "kLenovoPre", "lenovo_pre"],
    // [1, "kDoovPre", "doov_pre"],
    // [1, "kCoolpadPre", "coolpad_pre"],
    // [1, "k189Store", "189store"],
    // [1, "kLanYue", "lanyue"],
    // [1, "kLiQu", "liqu"],
    // [1, "kPaoJiao", "paojiao"],
    // [1, "k3533", "3533"],
    // [1, "kWeiYunJiQu", "weiyunjiqu"],
    // [1, "k3GRoad", "3groad"],
    // [1, "kSj", "sj"],
    // [1, "kUC", "uc"],
    // [1, "kLenovoGame", "lenovogame"],
    // [1, "kSina", "sina"],
    // [1, "kMobileMM", "mobilemm"],
    // [1, "kAndroidMM", "androidmm"],
    // [1, "kSpringMM", "springmm"],
    // [1, "kSogou", "sogou"],
    // [1, "kSogouSearch", "sgsearch"],
    // [1, "kSogouGame", "sggame"],
    // [1, "kLetv", "letv"],
    // [1, "kVivo", "vivo"],
    // [1, "kLvAn", "lvan"],
    // [1, "kHTC", "htc"],
    // [1, "kMT", "mt"],
    // [1, "kZY", "zy"],
    // [1, "kLemon", "lemon"],
    // [1, "kMZ", "mz"],
    // [1, "kFeiLiu", "feiliu"],
    // [1, "k9Bang", "9bang"],
    // [1, "kDangLe", "dangle"],
    // [1, "kJJ", "jj"],
    // [1, "kLeshop", "leshop"],
    // [1, "kBaidule", "baidule"],
    // [1, "kSamsung", "samsung"],
    // [1, "kZm", "zm"],
    // [1, "kAoruan", "aoruan"],
    // [1, "kSohu", "sohu"],
    // [1, "kYiwan", "yiwan"],
    // [1, "kDK", "dk"],
    // [1, "kALI", "ali"],
    // [1, "kBaiduLemon", "baidulemon"],
    // [1, "kBaiduWifi", "baiduwifi"],
    // [1, "kPP", "pp"],
    // [1, "kTF", "tf"],
    // [1, "kWTWDPre", "wtwd_pre"],
    // [1, "kHaixin", "haixin"],
    // [1, "kNubia", "nubia"],
    // [1, "k2345", "2345"],
    // [1, "kMuZhi", "muzhi"],
    // [1, "kKuaikan", "kuaikan"]
)
PlatformAuthEnum = table(
    [1, "kGuest", 0],
    [1, "kWeChat", 1],
    [1, "kQQ", 2],
    // [1, "kWeibo", 3],
    // [1, "kMI", 4],
    // [1, "k360", 5],
    // [1, "kPhone", 6],
    // [1, "kWDJ", 7]
)
PlatformAuthDetail = table(
    [1, PlatformAuthEnum.kGuest, table([1, "name", "guest"], [1, "localization", ""])],
    // [1, PlatformAuthEnum.kWeibo, table([1, "name", "weibo"], [1, "localization", getText("platform.weibo")])],
    [1, PlatformAuthEnum.kQQ, table([1, "name", "qq"], [1, "localization", getText("platform.qq")])],
    // [1, PlatformAuthEnum.kWDJ, table([1, "name", "wandoujia"], [1, "localization", getText("platform.wdj")])],
    // [1, PlatformAuthEnum.kMI, table([1, "name", "migame"], [1, "localization", getText("platform.mi")])],
    // [1, PlatformAuthEnum.k360, table([1, "name", "360"], [1, "localization", getText("platform.360")])],
    // [1, PlatformAuthEnum.kPhone, table([1, "name", "phone"], [1, "localization", getText("platform.phone")])],
    // [1, PlatformAuthEnum.kWeChat, table([1, "name", "weixin"], [1, "localization", getText("platform.wechat")])]
)
TelecomOperators = table(
    [1, "NO_SIM", -1],
    [1, "UNKNOWN", 0],
    [1, "CHINA_MOBILE", 1],
    [1, "CHINA_UNICOM", 2],
    [1, "CHINA_TELECOM", 3]
)
PaymentMode = table(
    [1, "kUnknown", 0],
    [1, "kSms", 1],
    [1, "kThirdParty", 2]
)
Payments = table(
    [1, "UNSUPPORT", 0],
    // [1, "CHINA_MOBILE", 1],
    // [1, "CHINA_UNICOM", 2],
    // [1, "CHINA_TELECOM", 3],
    // [1, "WDJ", 4],
    [1, "QQ", 5],
    // [1, "MI", 6],
    // [1, "QIHOO", 7],
    // [1, "MDO", 8],
    // [1, "CHINA_MOBILE_GAME", 9],
    // [1, "DUOKU", 10],
    [1, "WECHAT", 11],
    // [1, "ALIPAY", 12],
    // [1, "WO3PAY", 13],
    // [1, "VIVO", 14],
    // [1, "WIND_MILL", 15],
    // [1, "IOS_RMB", 16],
    // [1, "TELECOM3PAY", 17],
    // [1, "ALI_QUICK_PAY", 18],
    // [1, "ALI_SIGN_PAY", 19],
    // [1, "WECHAT_QUICK_PAY", 20],
    // [1, "HUAWEI", 21],
    // [1, "QQ_WALLET", 22],
    // [1, "MI_ALIPAY", 23],
    // [1, "MI_WXPAY", 24],
    // [1, "VIVO_ALI", 25],
    // [1, "VIVO_WX", 26],
    // [1, "QIHOO_WX", 27],
    // [1, "QIHOO_ALI", 28]
)
PaymentNames = table(
    [1, Payments.UNSUPPORT, "UNSUPPORT"],
    [1, Payments.CHINA_MOBILE, "CHINA_MOBILE"],
    [1, Payments.CHINA_UNICOM, "CHINA_UNICOM"],
    [1, Payments.CHINA_TELECOM, "CHINA_TELECOM"],
    [1, Payments.WDJ, "WDJ"],
    [1, Payments.QQ, "QQ"],
    [1, Payments.MI, "MI"],
    [1, Payments.QIHOO, "QIHOO"],
    [1, Payments.MDO, "MDO"],
    [1, Payments.CHINA_MOBILE_GAME, "CHINA_MOBILE_GAME"],
    [1, Payments.DUOKU, "DUOKU"],
    [1, Payments.WECHAT, "WECHAT"],
    [1, Payments.ALIPAY, "ALIPAY"],
    [1, Payments.WO3PAY, "WO3PAY"],
    [1, Payments.VIVO, "VIVO"],
    [1, Payments.VIVO_ALI, "VIVO_ALI"],
    [1, Payments.VIVO_WX, "VIVO_WX"],
    [1, Payments.TELECOM3PAY, "TELECOM3PAY"],
    [1, Payments.HUAWEI, "HUAWEI"],
    [1, Payments.QQ_WALLET, "QQ_WALLET"],
    [1, Payments.MI_ALIPAY, "MI_ALIPAY"],
    [1, Payments.MI_WXPAY, "MI_WXPAY"],
    [1, Payments.QIHOO_ALI, "QIHOO_ALI"],
    [1, Payments.QIHOO_WX, "QIHOO_WX"]
)
UserProductPayTypeRef = table(
    [1, "ingame", 3],
    [1, "alipay", 4],
    [1, "wechat", 5],
    [1, "qq", 6],
    [1, "huawei", 7],
    [1, "mi_alipay", 8],
    [1, "mi_wxpay", 9],
    [1, "qihoo_ali", 10],
    [1, "qihoo_wx", 11],
    [1, "wo3pay", 12],
    [1, "vivo", 13],
    [1, "vivo_wx", 14],
    [1, "vivo_ali", 15]
)
PaymentsNeedPreOrder = table(
    [0, Payments.WDJ],
    [0, Payments.QIHOO],
    [0, Payments.MI],
    [0, Payments.MI_ALIPAY],
    [0, Payments.MI_WXPAY]
)
PlatformPaymentThirdPartyEnum = table(
    [1, "kUnsupport", Payments.UNSUPPORT],
    [1, "kQQ", Payments.QQ],
    // [1, "kWDJ", Payments.WDJ],
    // [1, "kMI", Payments.MI],
    // [1, "k360", Payments.QIHOO],
    // [1, "kDUOKU", Payments.DUOKU],
    [1, "kWECHAT", Payments.WECHAT],
    // [1, "kALIPAY", Payments.ALIPAY],
    // [1, "kALI_QUICK_PAY", Payments.ALI_QUICK_PAY],
    // [1, "kWO3PAY", Payments.WO3PAY],
    // [1, "kVIVO", Payments.VIVO],
    // [1, "kTELECOM3PAY", Payments.TELECOM3PAY],
    // [1, "kHUAWEI", Payments.HUAWEI],
    // [1, "kQQ_WALLET", Payments.QQ_WALLET],
    // [1, "kMI_ALIPAY", Payments.MI_ALIPAY],
    // [1, "kMI_WXPAY", Payments.MI_WXPAY]
)
PlatformPaymentChinaMobileEnum = table(
    [1, "kUnsupport", Payments.UNSUPPORT],
    [1, "kCMCC", Payments.CHINA_MOBILE],
    [1, "kCMGAME", Payments.CHINA_MOBILE_GAME],
    // [1, "kMDO", Payments.MDO]
)
PlatformPaymentChinaUnicomEnum = table([1, "kUnsupport", Payments.UNSUPPORT], [1, "kUnicom", Payments.CHINA_UNICOM])
PlatformPaymentChinaTelecomEnum = table([1, "kUnsupport", Payments.UNSUPPORT], [1, "kTelecom", Payments.CHINA_TELECOM])
PlatformShareEnum = table(
    [1, "kWechat", 1],
    // [1, "kMiTalk", 2],
    // [1, "kWeibo", 3],
    // [1, "k360", 4],
    [1, "kQQ", 5]
)
PlatformPayType = table(
    [1, "kNormal", 1],
    [1, "kWechat", 2],
    // [1, "kAlipay", 3],
    // [1, "kVivo", 4],
    // [1, "kQihoo", 5],
    // [1, "kWandoujia", 6],
    [1, "kQQ", 7],
    // [1, "kMI", 8],
    // [1, "kHuaWei", 9],
    // [1, "kQQWallet", 10],
    // [1, "kMIAlipay", 11],
    // [1, "kMIWxpay", 12]
)
// AndroidHasPhonePlatformNames = table([0, PlatformNameEnum.kTF])
// var AndroidPlatformConfigs = table(
//     [1, "kHE", table(
//         [1, "name", PlatformNameEnum.kHE],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, PlatformPaymentThirdPartyEnum.kALIPAY], [0, PlatformPaymentThirdPartyEnum.kWECHAT])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kCMCC])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnicom],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kTelecom]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "kCMCCMM", table(
//         [1, "name", PlatformNameEnum.kCMCCMM],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, Payments.UNSUPPORT])],
//             [1, "chinaMobilePayment", table([0, Payments.CHINA_MOBILE])],
//             [1, "chinaUnicomPayment", Payments.CHINA_UNICOM],
//             [1, "chinaTelecomPayment", Payments.CHINA_TELECOM]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "kCMCCMM_2", table(
//         [1, "name", null],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, PlatformPaymentThirdPartyEnum.kWECHAT], [0, PlatformPaymentThirdPartyEnum.kALIPAY])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kCMCC])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnicom],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kTelecom]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "kQQ", table(
//         [1, "name", PlatformNameEnum.kQQ],
//         [1, "authConfig", PlatformAuthEnum.kQQ],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, PlatformPaymentThirdPartyEnum.kQQ])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kCMCC])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnicom],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kTelecom]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat], [0, PlatformShareEnum.kQQ])]
//     )],
//     [1, "k360", table(
//         [1, "name", PlatformNameEnum.k360],
//         [1, "authConfig", PlatformAuthEnum.k360],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, Payments.QIHOO_WX], [0, Payments.QIHOO_ALI])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kCMCC])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnicom],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kTelecom]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat], [0, PlatformShareEnum.k360])]
//     )],
//     [1, "kMiPad", table(
//         [1, "name", PlatformNameEnum.kMiPad],
//         [1, "authConfig", PlatformAuthEnum.kMI],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, PlatformPaymentThirdPartyEnum.kMI])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kUnsupport])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnsupport],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kUnsupport]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "kMiTalk", table(
//         [1, "name", PlatformNameEnum.kMiTalk],
//         [1, "authConfig", PlatformAuthEnum.kMI],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, PlatformPaymentThirdPartyEnum.kUnsupport])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kCMCC])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnicom],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kTelecom]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kMiTalk])]
//     )],
//     [1, "kNoNetWorkMode", table(
//         [1, "name", null],
//         [1, "authConfig", PlatformAuthEnum.kGuest],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, PlatformPaymentThirdPartyEnum.kUnsupport])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kUnsupport])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnsupport],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kUnsupport]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kUnsupport])]
//     )],
//     [1, "kCUCCWO", table(
//         [1, "name", PlatformNameEnum.kCUCCWO],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, Payments.WO3PAY])],
//             [1, "chinaMobilePayment", table()],
//             [1, "chinaUnicomPayment", Payments.UNSUPPORT],
//             [1, "chinaTelecomPayment", Payments.UNSUPPORT]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "k3GRoad", table(
//         [1, "name", PlatformNameEnum.k3GRoad],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, PlatformPaymentThirdPartyEnum.kWECHAT], [0, PlatformPaymentThirdPartyEnum.kALIPAY])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kUnsupport])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnicom],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kUnsupport]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "kCooou", table(
//         [1, "name", PlatformNameEnum.kCooou],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, PlatformPaymentThirdPartyEnum.kWECHAT], [0, PlatformPaymentThirdPartyEnum.kALIPAY])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kUnsupport])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnsupport],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kTelecom]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "kCMGame", table(
//         [1, "name", PlatformNameEnum.kCMGame],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, PlatformPaymentThirdPartyEnum.kUnsupport])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kCMGAME])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnsupport],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kUnsupport]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "kHEMM", table(
//         [1, "name", PlatformNameEnum.kHEMM],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, PlatformPaymentThirdPartyEnum.kUnsupport])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kCMCC])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnsupport],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kUnsupport]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "kHEWithoutCM", table(
//         [1, "name", null],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, PlatformPaymentThirdPartyEnum.kWECHAT], [0, PlatformPaymentThirdPartyEnum.kALIPAY])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kUnsupport])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnicom],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kTelecom]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "kHEWithoutMM", table(
//         [1, "name", null],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, PlatformPaymentThirdPartyEnum.kWECHAT], [0, PlatformPaymentThirdPartyEnum.kALIPAY])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kCMGAME])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnicom],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kTelecom]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "kOppo", table(
//         [1, "name", PlatformNameEnum.kOppo],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, PlatformPaymentThirdPartyEnum.kWECHAT], [0, PlatformPaymentThirdPartyEnum.kALIPAY])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kCMCC])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnicom],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kTelecom]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "kSj", table(
//         [1, "name", PlatformNameEnum.kSj],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, PlatformPaymentThirdPartyEnum.kWECHAT], [0, PlatformPaymentThirdPartyEnum.kALIPAY])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kCMCC])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnicom],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kTelecom]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "kMI", table(
//         [1, "name", PlatformNameEnum.kMI],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, Payments.MI_WXPAY], [0, Payments.MI_ALIPAY])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kCMCC])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnicom],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kTelecom]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "kHEWithout3rdPay", table(
//         [1, "name", null],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, PlatformPaymentThirdPartyEnum.kUnsupport])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kCMCC])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnicom],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kTelecom]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "kHuaWei", table(
//         [1, "name", PlatformNameEnum.kHuaWei],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, Payments.HUAWEI])],
//             [1, "chinaMobilePayment", table([0, Payments.CHINA_MOBILE])],
//             [1, "chinaUnicomPayment", Payments.CHINA_UNICOM],
//             [1, "chinaTelecomPayment", Payments.CHINA_TELECOM]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "k189Store", table(
//         [1, "name", PlatformNameEnum.k189Store],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table()],
//             [1, "chinaMobilePayment", table([0, Payments.CHINA_MOBILE])],
//             [1, "chinaUnicomPayment", Payments.CHINA_UNICOM],
//             [1, "chinaTelecomPayment", Payments.CHINA_TELECOM]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "kVivo", table(
//         [1, "name", PlatformNameEnum.kVivo],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, Payments.VIVO_WX], [0, Payments.VIVO_ALI])],
//             [1, "chinaMobilePayment", table([0, Payments.CHINA_MOBILE])],
//             [1, "chinaUnicomPayment", Payments.CHINA_UNICOM],
//             [1, "chinaTelecomPayment", Payments.CHINA_TELECOM]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )],
//     [1, "kLetv", table(
//         [1, "name", PlatformNameEnum.kLetv],
//         [1, "authConfig", table([0, PlatformAuthEnum.kWeibo], [0, PlatformAuthEnum.kQQ])],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", table([0, PlatformPaymentThirdPartyEnum.kALIPAY], [0, PlatformPaymentThirdPartyEnum.kWECHAT])],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kCMCC])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnicom],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kTelecom]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )]
// )
// var ForkPlatformMap = table(
//     [1, "kHE", table(
//         [0, PlatformNameEnum.kCoolpad],
//         [0, PlatformNameEnum.kUUCun],
//         [0, PlatformNameEnum.kJinShan],
//         [0, PlatformNameEnum.kBBK],
//         [0, PlatformNameEnum.kHTC],
//         [0, PlatformNameEnum.kJinli],
//         [0, PlatformNameEnum.kYouKu],
//         [0, PlatformNameEnum.kSamsung],
//         [0, PlatformNameEnum.kZm],
//         [0, PlatformNameEnum.kDangLe],
//         [0, PlatformNameEnum.kLemon],
//         [0, PlatformNameEnum.kALI],
//         [0, PlatformNameEnum.kMZ],
//         [0, PlatformNameEnum.kCoolpadPre],
//         [0, PlatformNameEnum.kTF],
//         [0, PlatformNameEnum.kWDJ],
//         [0, PlatformNameEnum.kAnZhi],
//         [0, PlatformNameEnum.kUC],
//         [0, PlatformNameEnum.kPP],
//         [0, PlatformNameEnum.kLenovo],
//         [0, PlatformNameEnum.kLenovopc],
//         [0, PlatformNameEnum.kSogou],
//         [0, PlatformNameEnum.kSogouSearch],
//         [0, PlatformNameEnum.kSogouGame],
//         [0, PlatformNameEnum.kAoruan],
//         [0, PlatformNameEnum.kHaixin],
//         [0, PlatformNameEnum.kNubia],
//         [0, PlatformNameEnum.kTYD],
//         [0, PlatformNameEnum.k2345],
//         [0, PlatformNameEnum.kMuZhi],
//         [0, PlatformNameEnum.kKuaikan],
//         [0, PlatformNameEnum.kBaiDuApp],
//         [0, PlatformNameEnum.kBaiDuTieBa],
//         [0, PlatformNameEnum.kDuoku],
//         [0, PlatformNameEnum.k91]
//     )],
//     [1, "kCMCCMM", table([0, PlatformNameEnum.kMobileMM])],
//     [1, "kCMCCMM_2", table(
//         [0, PlatformNameEnum.kSina],
//         [0, PlatformNameEnum.kSpringMM],
//         [0, PlatformNameEnum.kAndroidMM],
//         [0, PlatformNameEnum.kLvAn],
//         [0, PlatformNameEnum.kMT],
//         [0, PlatformNameEnum.kFeiLiu],
//         [0, PlatformNameEnum.k9Bang],
//         [0, PlatformNameEnum.kYiwan]
//     )],
//     [1, "kHEWithoutCM", table(
//         [0, PlatformNameEnum.kLanYue],
//         [0, PlatformNameEnum.kPaoJiao],
//         [0, PlatformNameEnum.kLiQu],
//         [0, PlatformNameEnum.k3533],
//         [0, PlatformNameEnum.kWeiYunJiQu]
//     )],
//     [1, "kHEWithout3rdPay", table([0, PlatformNameEnum.kJJ])],
//     [1, "kQQ", table(
//         [0, PlatformNameEnum.kYYB_CENTER],
//         [0, PlatformNameEnum.kYYB_MARKET],
//         [0, PlatformNameEnum.kYYB_JINSHAN],
//         [0, PlatformNameEnum.kYYB_BROWSER],
//         [0, PlatformNameEnum.kYYB_ZONE],
//         [0, PlatformNameEnum.kYYB_VIDEO],
//         [0, PlatformNameEnum.kYYB_NEWS],
//         [0, PlatformNameEnum.kYYB_QQ],
//         [0, PlatformNameEnum.kYYB_PC],
//         [0, PlatformNameEnum.kYYB_CORE],
//         [0, PlatformNameEnum.kYYB_SHOP],
//         [0, PlatformNameEnum.kYYB_TMS_CENTER],
//         [0, PlatformNameEnum.kYYB_TMS_SHOP],
//         [0, PlatformNameEnum.kYYB_GUANJIA]
//     )],
//     [1, "kHEWithoutMM", table(
//         [0, PlatformNameEnum.kBaidule],
//         [0, PlatformNameEnum.kSohu],
//         [0, PlatformNameEnum.kBaiduLemon],
//         [0, PlatformNameEnum.kBaiduWifi]
//     )]
// )
// var IOSPlatformConfigs = table([1, "kIOS", table(
//         [1, "name", PlatformNameEnum.kIOS],
//         [1, "authConfig", PlatformAuthEnum.kQQ],
//         [1, "paymentConfig", table(
//             [1, "thirdPartyPayment", PlatformPaymentThirdPartyEnum.kUnsupport],
//             [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kUnsupport])],
//             [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnsupport],
//             [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kUnsupport]
//         )],
//         [1, "shareConfig", table([0, PlatformShareEnum.kWechat])]
//     )])

var WIN32PlatformConfigs = table([1, "kHE", table(
        [1, "name", PlatformNameEnum.kHE],
        [1, "authConfig", PlatformAuthEnum.kGuest],
        [1, "paymentConfig", table(
            [1, "thirdPartyPayment", PlatformPaymentThirdPartyEnum.kUnsupport],
            [1, "chinaMobilePayment", table([0, PlatformPaymentChinaMobileEnum.kUnsupport])],
            [1, "chinaUnicomPayment", PlatformPaymentChinaUnicomEnum.kUnsupport],
            [1, "chinaTelecomPayment", PlatformPaymentChinaTelecomEnum.kUnsupport]
        )],
        [1, "shareConfig", table()]
    )])
var NeedPayCheckTable = table(
    // [0, Payments.WDJ],
    // [0, Payments.MI],
    // [0, Payments.QIHOO],
    [0, Payments.WECHAT],
    // [0, Payments.ALIPAY],
    [0, Payments.QQ],
    // [0, Payments.HUAWEI],
    // [0, Payments.QQ_WALLET],
    // [0, Payments.MI_ALIPAY],
    // [0, Payments.MI_WXPAY]
)
PlatformConfig = table()
var currentPayType = PlatformPayType.kNormal
function isPlatformLike(pfList, pfName) {
    if (!pfList || type(pfList) !== "table") {
        return false
    }
    for (var i = 1, v = HE_LIKE[1]; v; i++, v = HE_LIKE[i]) {
        if (androidPlatformName === v) {
            return true
        }
    }
}
function initPlatformConfig() {
    if (__ANDROID) {
        var androidPlatformName = he.StartupConfig.getInstance().getPlatformName()
        var cfg = luajava.bindClass("com.happyelements.AndroidClover.StartupConfig")
        cc.log(cfg.getPlatformName())
        cc.log("RRR  initPlatformConfig  androidPlarformName = " + tostring(androidPlatformName))
        if (PrepackageUtil.isPreNoNetWork()) {
            PlatformConfig = AndroidPlatformConfigs.kNoNetWorkMode
            PlatformConfig.name = androidPlatformName
            cc.log("RRR  预装包 platform config name: " + PlatformConfig.name)
            return 
        }
        // 预定义平台
        for (var k in AndroidPlatformConfigs) {
            var v = AndroidPlatformConfigs[k]
            if (androidPlatformName === v.name) {
                PlatformConfig = v
                cc.log("RRR  预定义平台 platform config name: " + PlatformConfig.name)
                return 
            }
        }
        // 派生平台, 仅平台名与原始平台不同, 如果存在其他差异则需要在预定义中直接声明平台
        for (var srcPlatform in ForkPlatformMap) {
            var forkPlatforms = ForkPlatformMap[srcPlatform]
            if (table.includes(forkPlatforms, androidPlatformName)) {
                PlatformConfig = AndroidPlatformConfigs[srcPlatform]
                PlatformConfig.name = androidPlatformName
                cc.log("RRR  派生平台 platform config name: " + PlatformConfig.name + " fork from: " + srcPlatform)
                return 
            }
        }
        cc.log("RRR  缺少的默认HE_LIKE platform config name: " + tostring(androidPlarformName))
        PlatformConfig = AndroidPlatformConfigs.kHE
        PlatformConfig.name = androidPlatformName
    } else if (__IOS) {
        PlatformConfig = IOSPlatformConfigs.kIOS
    } else {
        PlatformConfig = WIN32PlatformConfigs.kHE
    }
}
initPlatformConfig()
// PlatformConfig.loadPayementConfig = function () {
//     var self = this
//     require("clover/payment/logic/PaymentRequire")
//     for (var _ in self.paymentConfig) {
//         var v = self.paymentConfig[_]
//         if (type(v) === "table") {
//             for (var _ = 1, payType = v[1]; payType; _++, payType = v[_]) {
//                 PaymentBase.create(payType)
//             }
//         } else if (v !== Payments.UNSUPPORT) {
//             PaymentBase.create(v)
//         }
//     }
// }
PlatformConfig.getForkSrc = function () {
    var self = this
    if (self.forkSrc) {
        return self.forkSrc
    }
    if (__WIN32) {
        self.forkSrc = "win32"
    } else if (__IOS) {
        self.forkSrc = "ios"
    } else {
        var packageName = _G.packageName
        self.forkSrc = string.gsub(packageName, "com.happyelements.AndroidClover.", "")
        if (self.forkSrc === "com.happyelements.AndroidClover") {
            self.forkSrc = "he"
        }
        he_log_info("getForkSrc:" + packageName + "-------" + self.forkSrc)
    }
    return self.forkSrc
}
PlatformConfig.isPlatform = function (platformName) {
    var self = this
    assert(platformName)
    return self.name === platformName
}
PlatformConfig.isAuthConfig = function (authConfig) {
    var self = this
    assert(authConfig)
    return self.authConfig === authConfig
}
PlatformConfig.hasAuthConfig = function (authConfig) {
    var self = this
    assert(authConfig)
    if (type(self.authConfig) === "table") {
        for (var _ in self.authConfig) {
            var v = self.authConfig[_]
            if (v === authConfig) {
                return true
            }
        }
        return false
    } else {
        return self.authConfig === authConfig
    }
}
PlatformConfig.isMultipleAuthConfig = function () {
    var self = this
    return type(self.authConfig) === "table" && $len(self.authConfig) > 1
}
PlatformConfig.getAuthConfigs = function () {
    var self = this
    if (type(self.authConfig) === "table") {
        return self.authConfig
    } else {
        return table([0, self.authConfig])
    }
}
// PlatformConfig.isBaiduPlatform = function () {
//     var self = this
//     return self.isPlatform(PlatformNameEnum.kDuoku) || self.isPlatform(PlatformNameEnum.k91) || self.isPlatform(PlatformNameEnum.kBaiDuApp) || self.isPlatform(PlatformNameEnum.kHao123) || self.isPlatform(PlatformNameEnum.kBaiDuTieBa)
// }
// PlatformConfig.isSogouPlatform = function () {
//     var self = this
//     return self.isPlatform(PlatformNameEnum.kSogou) || self.isPlatform(PlatformNameEnum.kSogouGame) || self.isPlatform(PlatformNameEnum.kSogouSearch)
// }
// PlatformConfig.isQQPlatform = function () {
//     var self = this
//     return self.isPlatform(PlatformNameEnum.kQQ) || self.isPlatform(PlatformNameEnum.kYYB_CENTER) || self.isPlatform(PlatformNameEnum.kYYB_MARKET) || self.isPlatform(PlatformNameEnum.kYYB_JINSHAN) || self.isPlatform(PlatformNameEnum.kYYB_BROWSER) || self.isPlatform(PlatformNameEnum.kYYB_ZONE) || self.isPlatform(PlatformNameEnum.kYYB_VIDEO) || self.isPlatform(PlatformNameEnum.kYYB_NEWS) || self.isPlatform(PlatformNameEnum.kYYB_QQ) || self.isPlatform(PlatformNameEnum.kYYB_PC) || self.isPlatform(PlatformNameEnum.kYYB_CORE) || self.isPlatform(PlatformNameEnum.kYYB_SHOP) || self.isPlatform(PlatformNameEnum.kYYB_TMS_CENTER) || self.isPlatform(PlatformNameEnum.kYYB_TMS_SHOP) || self.isPlatform(PlatformNameEnum.kYYB_GUANJIA)
// }
// PlatformConfig.isJJPlatform = function () {
//     var self = this
//     // body
//     // WARN: maybe multi result
//     return self.isPlatform(PlatformNameEnum.kJJ)
// }
PlatformConfig.isCMPaymentSwitchable = function () {
    var self = this
    if (type(self.paymentConfig.chinaMobilePayment) === "table" && table.includes(self.paymentConfig.chinaMobilePayment, PlatformPaymentChinaMobileEnum.kCMCC) && table.includes(self.paymentConfig.chinaMobilePayment, PlatformPaymentChinaMobileEnum.kCMGAME)) {
        return true
    }
    return false
}
PlatformConfig.getPlatformAuthDetail = function (authorType) {
    var self = this
    var authDetail = null
    if (authorType) {
        authDetail = PlatformAuthDetail[authorType]
    } else if (SnsProxy && SnsProxy.getAuthorizeType()) { // use default authorize type
        authDetail = PlatformAuthDetail[SnsProxy.getAuthorizeType()]
    }
    return authDetail
}
PlatformConfig.getPlatformAuthEnum = function (name) {
    var self = this
    for (var k in PlatformAuthDetail) {
        var v = PlatformAuthDetail[k]
        if (name === v.name) {
            return k
        }
    }
}
//@param tag PaymentNames
// 当tag == "ingame"返回当前sim卡支持的类形
PlatformConfig.getPaymentTypeByTag = function (tag) {
    var self = this
    tag = tag || ""
    var stag = string.lower(tag)
    if (tag === "ingame") {
        // WARN: maybe multi result
        return GameProxy.getInstance().getDefaultSmsPayment()
    } else {
        for (var k in PaymentNames) {
            var v = PaymentNames[k]
            if (string.lower(v) === stag) {
                return k
            }
        }
    }
    return Payments.UNSUPPORT
}
PlatformConfig.getPlatformNameLocalization = function (authorType) {
    var self = this
    if (self.isPlatform(PlatformNameEnum.kMiTalk)) {
        // WARN: maybe multi result
        return Localization.getInstance().getText("platform.mitalk")
    }
    var authDetail = self.getPlatformAuthDetail(authorType)
    if (authDetail && authDetail.localization) {
        return authDetail.localization
    } else {
        return ""
    }
}
PlatformConfig.getPlatformAuthName = function (authorType) {
    var self = this
    var authDetail = self.getPlatformAuthDetail(authorType)
    if (authDetail && authDetail.name) {
        return authDetail.name
    } else {
        return null
    }
}
PlatformConfig.setCurrentPayType = function (payType) {
    var self = this
    currentPayType = payType || PlatformPayType.kNormal
}
PlatformConfig.getCurrentPayType = function () {
    var self = this
    return currentPayType
}
//是否支持大额支付
PlatformConfig.isBigPayPlatform = function () {
    var self = this
    if ((PlatformConfig.isPlatform(PlatformNameEnum.kMiPad) || PlatformConfig.isPlatform(PlatformNameEnum.kVivo))) {
        return true
    }
    return false
}
PlatformConfig.isIngamePaySupport = function () {
    var self = this
    var operator = GameProxy.getInstance().getOperator()
    if (operator === TelecomOperators.CHINA_MOBILE) {
        if (GameProxy.getInstance().filterCMPayment() !== PlatformPaymentChinaMobileEnum.kUnsupport) {
            return true
        }
    } else if (operator === TelecomOperators.CHINA_UNICOM) {
        if (GameProxy.getInstance().filterCUPayment() !== PlatformPaymentChinaUnicomEnum.kUnsupport) {
            return true
        }
    } else if (operator === TelecomOperators.CHINA_TELECOM) {
        if (GameProxy.getInstance().filterCTPayment() !== PlatformPaymentChinaTelecomEnum.kUnsupport) {
            return true
        }
    }
    return false
}
PlatformConfig.getSupportPayment = function () {
    var self = this
    var supportPayment = table()
    if (PlatformConfig.isIngamePaySupport()) {
        table.insert(supportPayment, "ingame")
    }
    if (type(self.paymentConfig.thirdPartyPayment) === "table") {
        for (var _ in PlatformConfig.paymentConfig.thirdPartyPayment || table()) {
            var v = PlatformConfig.paymentConfig.thirdPartyPayment || table()[_]
            if (v !== PlatformPaymentThirdPartyEnum.kUnsupport) {
                table.insert(supportPayment, string.lower(PaymentNames[v]))
            }
        }
    }
    return supportPayment
}
// //已弃用
// PlatformConfig.getNeedForceThirdPartPayment = function () {
//     var self = this
//     var operator = GameProxy.getInstance().getOperator()
//     var forceThirdPartPayment = false
//     if (operator === TelecomOperators.CHINA_MOBILE) {
//         if (GameProxy.getInstance().filterCMPayment() === PlatformPaymentChinaMobileEnum.kUnsupport) {
//             forceThirdPartPayment = true
//         }
//     } else if (operator === TelecomOperators.CHINA_UNICOM) {
//         if (GameProxy.getInstance().filterCUPayment() === PlatformPaymentChinaUnicomEnum.kUnsupport) {
//             forceThirdPartPayment = true
//         }
//     } else if (operator === TelecomOperators.CHINA_TELECOM) {
//         if (GameProxy.getInstance().filterCTPayment() === PlatformPaymentChinaTelecomEnum.kUnsupport) {
//             forceThirdPartPayment = true
//         }
//     }
//     return forceThirdPartPayment
// }
// //已弃用
// PlatformConfig.isWechatPaySupport = function () {
//     var self = this
//     var forceThirdPartPayment = self.getNeedForceThirdPartPayment()
//     if (forceThirdPartPayment) {
//         if (type(self.paymentConfig.thirdPartyPayment) === "table") {
//             if (table.includes(self.paymentConfig.thirdPartyPayment, PlatformPaymentThirdPartyEnum.kWECHAT)) {
//                 return true
//             }
//         }
//     } else if (MaintenanceManager.getInstance().isEnabled("ConsumeSwitchWechat")) {
//         if (type(self.paymentConfig.thirdPartyPayment) === "table") {
//             if (table.includes(self.paymentConfig.thirdPartyPayment, PlatformPaymentThirdPartyEnum.kWECHAT)) {
//                 return true
//             }
//         }
//     }
//     return false
// }
// //已弃用
// PlatformConfig.isAliPaySupport = function () {
//     var self = this
//     var forceThirdPartPayment = self.getNeedForceThirdPartPayment()
//     if (forceThirdPartPayment) {
//         if (type(self.paymentConfig.thirdPartyPayment) === "table") {
//             if (table.includes(self.paymentConfig.thirdPartyPayment, PlatformPaymentThirdPartyEnum.kALIPAY)) {
//                 return true
//             }
//         }
//     } else if (MaintenanceManager.getInstance().isEnabled("ConsumeSwitchAli")) {
//         if (type(self.paymentConfig.thirdPartyPayment) === "table") {
//             if (table.includes(self.paymentConfig.thirdPartyPayment, PlatformPaymentThirdPartyEnum.kALIPAY)) {
//                 return true
//             }
//         }
//     }
//     return false
// }
// //已弃用
// PlatformConfig.isMarketWechatPaySupport = function () {
//     var self = this
//     var forceThirdPartPayment = self.getNeedForceThirdPartPayment()
//     if (forceThirdPartPayment) {
//         if (type(self.paymentConfig.thirdPartyPayment) === "table") {
//             if (table.includes(self.paymentConfig.thirdPartyPayment, PlatformPaymentThirdPartyEnum.kWECHAT)) {
//                 return true
//             }
//         }
//     } else if (MaintenanceManager.getInstance().isEnabled("NewGamePaymentWechat")) {
//         if (type(self.paymentConfig.thirdPartyPayment) === "table") {
//             if (table.includes(self.paymentConfig.thirdPartyPayment, PlatformPaymentThirdPartyEnum.kWECHAT)) {
//                 return true
//             }
//         }
//     }
//     return false
// }
// //已弃用
// PlatformConfig.isMarketAliPaySupport = function () {
//     var self = this
//     var forceThirdPartPayment = self.getNeedForceThirdPartPayment()
//     if (forceThirdPartPayment) {
//         if (type(self.paymentConfig.thirdPartyPayment) === "table") {
//             if (table.includes(self.paymentConfig.thirdPartyPayment, PlatformPaymentThirdPartyEnum.kALIPAY)) {
//                 return true
//             }
//         }
//     } else if (MaintenanceManager.getInstance().isEnabled("NewGamePaymentAli")) {
//         if (type(self.paymentConfig.thirdPartyPayment) === "table") {
//             if (table.includes(self.paymentConfig.thirdPartyPayment, PlatformPaymentThirdPartyEnum.kALIPAY)) {
//                 return true
//             }
//         }
//     }
//     return false
// }
// PlatformConfig.isVivoPaySupport = function () {
//     var self = this
//     //if MaintenanceManager:getInstance():isEnabled("ConsumeSwitchAli") then 
//     if (type(self.paymentConfig.thirdPartyPayment) === "table") {
//         if (table.includes(self.paymentConfig.thirdPartyPayment, PlatformPaymentThirdPartyEnum.kVIVO)) {
//             return true
//         }
//     }
//     //end
//     return false
// }
PlatformConfig.isNeedOrderSuccessCheck = function (paymentsType) {
    var self = this
    if (table.includes(NeedPayCheckTable, paymentsType)) {
        return true
    }
    return false
}
// PlatformConfig.getLastPlatformAuthName = function () {
//     var self = this
//     var lastLoginUserData = Localhost.readLastLoginUserData()
//     var name = null
//     if (lastLoginUserData && lastLoginUserData.authorType) {
//         var authDetail = PlatformAuthDetail[lastLoginUserData.authorType]
//         if (authDetail) {
//             name = authDetail.name
//         }
//     }
//     return name
// }
// PlatformConfig.getLastPlatformAuthType = function () {
//     var self = this
//     var lastLoginUserData = Localhost.readLastLoginUserData()
//     if (lastLoginUserData && lastLoginUserData.authorType) {
//         return lastLoginUserData.authorType
//     }
//     return null
// }
PlatformConfig.getLoginTypeName = function () {
    var self = this
    var lastLoginUserData = Localhost.readLastLoginUserData()
    var name = "guest"
    if (lastLoginUserData && lastLoginUserData.authorType) {
        var authDetail = PlatformAuthDetail[lastLoginUserData.authorType]
        if (authDetail) {
            name = authDetail.name
        }
    }
    return name
}
PlatformConfig.isCUCCWOPlatform = function () {
    var self = this
    // WARN: maybe multi result
    return self.isPlatform(PlatformNameEnum.kCUCCWO)
}
PlatformConfig.isSMSPayment = function (paymentType) {
    var self = this
    if (paymentType === Payments.CHINA_MOBILE || paymentType === Payments.CHINA_UNICOM || paymentType === Payments.CHINA_TELECOM || paymentType === Payments.CHINA_MOBILE_GAME || paymentType === Payments.WO3PAY || paymentType === Payments.TELECOM3PAY) {
        return true
    } else {
        return false
    }
}
